/** @format */
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import {
    HeadingColor,
    HeadingSize,
    HighlightColor,
} from '@mpb-com/feather/components/atoms/heading/types';
import { LinkVariant } from '@mpb-com/feather/components/atoms/link/types';
import React from 'react';

import { WrappedLink } from '@toucan/client/global/nextjs';

import { ConstrainedWrapper } from '@toucan/client/shared/components/constrained-wrapper';

import { DEFAULT_TEST_ID } from './constants';
import { VideoBlockProps } from './types';
import { StyledVideoBlock } from './video-block.styles';

export * from './types';

export { VideoBlockSkeleton } from './skeleton';

export const VideoBlock = ({
    heading,
    description,
    videoUrl,
    videoTitle,
    callToActions,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
}: VideoBlockProps) => {
    return (
        <StyledVideoBlock data-testid={dataTestId} className="video-block">
            <ConstrainedWrapper>
                <div className="video">
                    <iframe
                        width="100%"
                        height="100%"
                        src={videoUrl}
                        title={videoTitle}
                        allowFullScreen
                    />
                </div>
                <div className="content">
                    <Heading
                        className="heading"
                        size={HeadingSize.H2}
                        color={HeadingColor.TEXT_INVERSE}
                        highlightColor={HighlightColor.TEXT_ACCENT}
                    >
                        {heading}
                    </Heading>
                    <div
                        className="description"
                        data-testid={`${dataTestId}__description`}
                    >
                        {description}
                    </div>
                    <div className="call-to-action-container">
                        {callToActions.map(({ buttonUrl, buttonLabel }) => {
                            if (!buttonUrl || !buttonLabel) return null;
                            return (
                                <WrappedLink
                                    key={buttonUrl}
                                    href={buttonUrl}
                                    variant={LinkVariant.CUSTOM}
                                    passHref={true}
                                >
                                    <Button variant={ButtonVariant.TERTIARY}>
                                        {buttonLabel}
                                    </Button>
                                </WrappedLink>
                            );
                        })}
                    </div>
                </div>
            </ConstrainedWrapper>
        </StyledVideoBlock>
    );
};
